import { useCallback, useState } from 'react';
import type { CalendarPost } from '../types';
import type { CalendarPostActions } from './useCalendarPostActions';

interface UseCalendarDialogsProps {
  actions: CalendarPostActions;
  /** A deleted post closes its panel. */
  onDeleted: (post: CalendarPost) => void;
}

/**
 * "Delete this post?" of the Calendar. "Schedule all drafts of this day" has its own flow
 * (`useCalendarLaunch`).
 */
export function useCalendarDialogs({ actions, onDeleted }: UseCalendarDialogsProps) {
  const [pendingDelete, setPendingDelete] = useState<CalendarPost | null>(null);

  const askDelete = useCallback((post: CalendarPost) => setPendingDelete(post), []);
  const cancelDelete = useCallback(() => setPendingDelete(null), []);
  const confirmDelete = useCallback(() => {
    if (pendingDelete === null) {
      return;
    }
    const post = pendingDelete;
    actions
      .remove(post.uuid)
      .then((result) => {
        setPendingDelete(null);
        if (result.ok) {
          onDeleted(post);
        }
      })
      .catch(console.error);
  }, [actions, onDeleted, pendingDelete]);

  return { pendingDelete, askDelete, cancelDelete, confirmDelete };
}
